import {Navigate, Outlet} from "react-router-dom";
import {useIdentityAuth} from "../context/IdentityAuthContext";
import {useAuthPermissions} from "../hooks/useAuthPermissions";
import SkeletonLoadingTS from "../components/SkeletonLoadingTS";

const ProtectedLayout = ({roles}) => {
  const {isLoading, isAuthenticated} = useIdentityAuth();
  const {verifyRole} = useAuthPermissions();

  if (isLoading) {
    return <SkeletonLoadingTS />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/acceso" replace />;
  }

  if (!verifyRole(roles)) {
    return <Navigate to="/acceso?error=unauthorized" replace />;
  }

  return <Outlet />;
};

export default ProtectedLayout;
